var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFi18522004(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_580_70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.597 0.388916H10.7914C5.04912 0.388916 0.388672 5.04936 0.388672 10.7917V31.5972C0.388672 37.3396 5.04912 42 10.7914 42H31.597C37.3393 42 41.9998 37.3396 41.9998 31.5972V10.7917C41.9998 5.04936 37.3393 0.388916 31.597 0.388916ZM21.1942 31.5972C15.4519 31.5972 10.7914 26.9368 10.7914 21.1945C10.7914 15.4521 15.4519 10.7917 21.1942 10.7917C26.9366 10.7917 31.597 15.4521 31.597 21.1945C31.597 26.9368 26.9366 31.5972 21.1942 31.5972ZM32.3252 12.0816C31.1809 12.0816 30.2446 11.1454 30.2446 10.0011C30.2446 8.85678 31.1809 7.92053 32.3252 7.92053C33.4695 7.92053 34.4058 8.85678 34.4058 10.0011C34.4058 11.1454 33.4695 12.0816 32.3252 12.0816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1943 27.4361C24.6415 27.4361 27.436 24.6416 27.436 21.1944C27.436 17.7472 24.6415 14.9528 21.1943 14.9528C17.7471 14.9528 14.9526 17.7472 14.9526 21.1944C14.9526 24.6416 17.7471 27.4361 21.1943 27.4361Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_580_70"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFi18522004);
export default __webpack_public_path__ + "static/media/fi_18522004.0251a9e0e59f8fa946c3f084b6aed1fe.svg";
export { ForwardRef as ReactComponent };